import ModalController from 'webmodals/modal.controller'
import Design from 'emun.on-demand/lib/design'
import Media from 'webutils/media/media'
import DesignLayer from 'emun.on-demand/lib/design-layer'
import resolve from 'ioc/resolve'
import utils from 'emun.on-demand/lib/util'
import fabric from 'emun.on-demand/lib/fabric'


class CompositeImagePromptController extends ModalController {
    constructor($uibModalInstance, options) {
        super($uibModalInstance)
        const $ctrl = this;
        $ctrl.title = options.title || 'Configure Composite Image...';
        $ctrl.subTitle = options.subTitle || options.image.label;
        $ctrl.areas = options.productTemplate.areas;
        $ctrl.image = options.image;
        $ctrl.options = options;
        $uibModalInstance.closed.finally(() => $ctrl.designer.dispose());
        console.debug('CompositeImagePromptController', options);
        console.debug('$ctrl.image', $ctrl.image);
        console.debug('$ctrl.image.isDesign()', $ctrl.image.isDesign());
    }

    initializeDesigner(designer){
        console.debug('CompositeImagePromptController.initializeDesigner', designer);
        let $ctrl = this;
        $ctrl.designer = designer;
        designer.ready = false;
        designer.isLoading = true;
        designer.status = 'loading';
        designer.editorPopoverPlacement = 'left-top';

        let d = new Design($ctrl.image.isDesign() ? $ctrl.image : {
            id: $ctrl.image.id,
            url: $ctrl.image.url,
            predecessor: $ctrl.image,
            width: $ctrl.image.width,
            height: $ctrl.image.height,
            label: $ctrl.image.label,
            realm: 'CompositeImage',
            overscan:10,
            background: $ctrl.options.backgroundColor || '#fff',
            perspectives: [{
                canDesign:true,
                euid: $ctrl.image.euid,
                isProductImage:true,
                permanent:true,
                label: $ctrl.image.label,
                media: $ctrl.image,
                x: 0,
                y: 0,
                width: $ctrl.image.width,
                height: $ctrl.image.height,
            }],
            objects: $ctrl.generateAreaObjects()
        }, $ctrl.image.isDesign());
        console.debug('Design', d);
        designer.designs = [d];
        
        d.$hydrated.then(() => {
            //if(d.perspective && !d.perspective.media) 
            //    d.perspective.media = $ctrl.image;
            designer.activate(d);
            designer.ready = true;
            designer.isLoading = false;
            designer.status = 'ready';
            //designer.layers.shapes[0].select();
        });
    }

    generateAreaObjects() {
        const $ctrl = this;
        let objects = [];
        const cnt = $ctrl.areas.length;
        let max = {
            width: $ctrl.image.width/cnt,
            height: $ctrl.image.height/cnt
        };
        $ctrl.areas.forEach((area, i) => {
            let guide = {
                type: 'rect',
                euid: area.euid,
                area,
                layerId: 'EFI-' + (area.label || area.euid),
                left: i / cnt * $ctrl.image.width,
                top: i / cnt * $ctrl.image.height,
                width: area.width,
                height: area.height,
                fill: '#f500f5',
                perPixelTargetFind: false
            }
            guide.scaleX = guide.scaleY = utils.getContainScale(guide, max);

            area.overlays.forEach(o => {            
                if(guide.type !== 'image' && o.x === 0 && o.y === 0 && o.width === area.width && o.height === area.height){
                    guide.type = 'image';
                    guide.src = guide.url = o.media.img('medium');
                    //delete guide.fill;
                    console.warn('guide', guide);
                }
            });
            objects.push(guide);
        });
        return objects;
    }

    submit() {
        const $ctrl = this;
        const designer = $ctrl.designer;
        const design = designer.design;
        design.validateAndSave(false).then(res => {    
            Object.assign($ctrl.image, res.data);
            $ctrl.close($ctrl);
        });
    }
}

export default CompositeImagePromptController;